import type { SVGProps } from 'react'
const SvgSySend = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				d="m15.182 7.197-5.82 5.82a.75.75 0 0 0 0 1.061.75.75 0 0 0 1.06 0l5.82-5.82a.75.75 0 0 0 0-1.06.75.75 0 0 0-1.06 0"
				opacity={0.4}
			/>
			<path d="M19.252 1.828 3.162 6.477a1.97 1.97 0 0 0-1.394 1.617c-.096.708.218 1.5.918 1.927l6.658 4.07 4.006 6.593a1.97 1.97 0 0 0 1.92.923 1.97 1.97 0 0 0 1.623-1.378l4.773-15.963c.434-1.443-.967-2.857-2.414-2.438m.416 1.442c.383-.111.675.183.56.564v.002l-4.773 15.963a.41.41 0 0 1-.377.32.41.41 0 0 1-.445-.215l-4.082-6.713v-.002l-.002-.002-.018-.029-.033-.023a.75.75 0 0 0-.215-.227L3.467 8.74a.41.41 0 0 1-.213-.447.41.41 0 0 1 .324-.375z" />
		</g>
	</svg>
)
export default SvgSySend
